module.exports = __webpack_public_path__ + "img/icon_highlight_laohu.74a22112.png";